import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import ErpTemplate from '../../components/ErpTemplate';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

export default function Graficos() {
  const token = localStorage.getItem('token');
  const empresa = localStorage.getItem("empresa");
  const [filtro, setFiltro] = useState({
    empresa: empresa,
  }); //1 - pagar | 2 - receber
  const [dadosAreaChart, setDadosAreaChart] = useState([]);
  const [dadosPieChart, setDadosPieChart] = useState([]);
  const [carregadoLineChart, setCarregadoLineChart] = useState(false);
  const [carregadoPieChart, setCarregadoPieChart] = useState(false);

  // Cores para os gráficos
  const CORES_RECEITAS = '#00e396';
  const CORES_DESPESAS = '#FFaa00';
  const CORES_PIE = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc658', '#ff7300'];

  const buscar = () => {

    //pieChart
    api({
      method: "get",
      action: '/financeiroParcela/graficoDespesa',
      token: token,
      params: {
        ...filtro,
      }
    }).then(response => {
      const dadosFormatados = response.data.data.map((registro) => {
        return {
          name: registro.nome,
          value: registro.total
        };
      });
      setDadosPieChart(dadosFormatados);
      setCarregadoPieChart(true);
    }).catch(err => {
      //console.log(err)
    });

    //lineChart (Area Chart)
    api({
      method: "get",
      action: '/financeiroParcela/graficoReceitaDespesa',
      token: token,
      params: {
        ...filtro,
      }
    }).then(response => {
      const dadosFormatados = response.data.data.map((registro) => {
        return {
          name: registro.nome,
          receitas: registro.receitas,
          despesas: registro.despesas
        };
      });
      setDadosAreaChart(dadosFormatados);
      setCarregadoLineChart(true);
    }).catch(err => {
      //console.log(err)
    });
  };

  useEffect(() => { //onload
    buscar();
  }, 
  // eslint-disable-next-line
  []);

  // Formatação customizada para tooltip do Pie Chart
  const CustomTooltipPie = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
          <p style={{ margin: 0, fontWeight: 'bold' }}>{payload[0].name}</p>
          <p style={{ margin: 0 }}>R$ {payload[0].value.toFixed(2)}</p>
        </div>
      );
    }
    return null;
  };

  // Formatação customizada para label do Pie Chart
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, name, value }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text 
        x={x} 
        y={y} 
        fill="white" 
        textAnchor={x > cx ? 'start' : 'end'} 
        dominantBaseline="central"
        fontSize={12}
        fontWeight="bold"
      >
        {`${name}: R$ ${value.toFixed(2)}`}
      </text>
    );
  };

  return (
    <ErpTemplate>
      <div className="main-content container-fluid">
        <div className="page-title">
          <h3>Gráficos</h3>
        </div>
        <section id="multiple-column-form">
          <div className="row match-height">
            <div className="col-sm-6">
              <div className="card">
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12">
                        <h5 style={{ marginBottom: '20px', textAlign: 'center' }}>Receitas e Despesas</h5>
                        {carregadoLineChart ? (
                          <ResponsiveContainer width="100%" height={400}>
                            <AreaChart
                              data={dadosAreaChart}
                              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                            >
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Area 
                                type="monotone" 
                                dataKey="receitas" 
                                stackId="1"
                                stroke={CORES_RECEITAS} 
                                fill={CORES_RECEITAS}
                                name="Receitas"
                              />
                              <Area 
                                type="monotone" 
                                dataKey="despesas" 
                                stackId="1"
                                stroke={CORES_DESPESAS} 
                                fill={CORES_DESPESAS}
                                name="Despesas"
                              />
                            </AreaChart>
                          </ResponsiveContainer>
                        ) : <div>Carregando...</div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="card">
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12">
                        <h5 style={{ marginBottom: '20px', textAlign: 'center' }}>Despesas</h5>
                        {carregadoPieChart ? (
                          <ResponsiveContainer width="100%" height={400}>
                            <PieChart>
                              <Pie
                                data={dadosPieChart}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                label={renderCustomLabel}
                                outerRadius={120}
                                fill="#8884d8"
                                dataKey="value"
                              >
                                {dadosPieChart.map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={CORES_PIE[index % CORES_PIE.length]} />
                                ))}
                              </Pie>
                              <Tooltip content={<CustomTooltipPie />} />
                            </PieChart>
                          </ResponsiveContainer>
                        ) : <div>Carregando...</div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </ErpTemplate>
  );
}
